import { SpriteSvgType } from '../../../components/sprite-svg';
import { strToJson } from '../../../lib';
import { GameMenuKey } from '../../../model';
import {
  IAPIServiceConfigItem,
  IServiceApplyConfig,
} from '../../../model/api-modules';
import { ISystemMenuItem, SystemMenuType } from '../../../model/system/menu';

export const getServiceIcon = (
  serviceConfig: IAPIServiceConfigItem | null
): SpriteSvgType => {
  const jsonConfig = strToJson<IServiceApplyConfig>(
    serviceConfig?.JsonConfig || ''
  );
  return (jsonConfig?.icon || '') as SpriteSvgType;
};

const getServiceUrl = (path: string, gameId?: string, envId?: number) => {
  if (path.startsWith('http')) {
    return path;
  }
  return `${path}/${gameId}/${envId}`;
};

export const convertService2Menu = (
  service: IAPIServiceConfigItem,
  gameId?: string,
  envId?: number
): ISystemMenuItem => {
  return {
    type: SystemMenuType.Menu,
    id: `${service.id}`,
    name: service.Name,
    icon: service.IconURL,
    fixed: true,
    url: getServiceUrl(service.Name, gameId, envId),
    servicePath: service.ServicePath,
    supportType: service.SupportType,
    business: service.Business,
    status: service.Status,
  };
};

export const convert2Menu = (
  serviceConfigs: ReadonlyArray<IAPIServiceConfigItem>,
  gameId?: string,
  envId?: number
) => {
  // 转换菜单
  const temp: Array<Array<IAPIServiceConfigItem>> = [];
  const menus: Array<ISystemMenuItem> = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < serviceConfigs.length; i++) {
    const { ParentSort: parentSort } = serviceConfigs[i];
    const index = parentSort - 1;
    temp[index] = [...(temp[index] ? temp[index] : []), serviceConfigs[i]];
  }
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < temp.length; i++) {
    menus[i] = {
      type: SystemMenuType.Group,
      name: temp[i][0].ParentName,
      fixed: true,
      servicePath: '',
      id: '0',
      subMenus: temp[i]
        .sort((a, b) => +a.Sort - +b.Sort)
        .map((v) => {
          return convertService2Menu(v, gameId, envId);
        }),
    };
  }
  return menus;
};

export const getCurrentSelectedMenuID = (serviceID?: string) => {
  if (serviceID) {
    return serviceID;
  }
  if (location.pathname.startsWith('/console/overview')) {
    return GameMenuKey.Overview;
  }
  if (location.pathname.startsWith('/console/game-info')) {
    return GameMenuKey.GameInfo;
  }
  if (location.pathname.startsWith('/console/all-product')) {
    return GameMenuKey.AllProduct;
  }
  return '';
};
